var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 231.48 75.418",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: 1.6996
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.536 0.25173c10.877 0 16.486 5.4386 16.486 5.4386l-3.2292 4.7588s-5.0987-4.4189-12.747-4.4189c-10.707 0-17.166 7.818-17.166 17.506 0 10.537 7.1382 17.845 16.826 17.845 7.818 0 12.917-5.6086 12.917-5.6086v-6.6283h-7.4781v-5.6086h13.257v22.944h-5.6086v-4.7588h-0.16995s-4.9288 5.6086-13.936 5.6086c-12.237 0-22.434-9.6875-22.434-23.624 0.16996-13.087 10.027-23.454 23.284-23.454z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.666 33.142h-17.166l-4.5888 13.087h-6.6283l16.316-45.548h6.6283l16.316 45.548h-6.6283zm-8.6678-26.173s-1.0197 4.079-1.8695 6.4583l-5.0987 14.446h13.766l-5.0987-14.446c-0.50987-2.2094-1.5296-6.4583-1.6996-6.4583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.76 0.67983h6.6283l10.367 24.644c1.0197 2.5493 2.2094 6.1184 2.2094 6.1184h0.16995s1.1897-3.5691 2.2094-6.1184l10.367-24.644h6.6283l3.739 45.548h-6.2884l-2.2094-28.723c-0.16995-2.7193 0-6.6283 0-6.6283h-0.16995s-1.3597 4.2489-2.3794 6.6283l-9.0077 20.565h-5.6086l-9.0077-20.565c-1.0198-2.3794-2.3794-6.7983-2.3794-6.7983h-0.16995s0 4.079-0.16996 6.7983l-2.2094 28.723h-6.4583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.82 36.371s4.7588 4.9287 11.557 4.9287c4.2489 0 7.818-2.3794 7.818-6.6283 0-9.8575-22.094-7.648-22.094-21.754 0-7.1382 6.1184-12.747 14.616-12.747s12.917 4.5888 12.917 4.5888l-2.8893 5.2687s-4.2489-3.909-10.027-3.909c-4.7588 0-8.3279 3.0592-8.3279 6.6283 0 9.3476 22.094 6.9682 22.094 21.584 0 6.9682-5.4386 12.747-14.446 12.747-9.6875 0-15.126-5.9485-15.126-5.9485z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "aria-label": "ENGINE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m45.469 58.966h11.232v1.488h-9.576v6h8.568v1.488h-8.568v6.312h9.888v1.488h-11.544z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.237 58.966h1.632v16.776h-1.752l-10.392-14.208v14.208h-1.656v-16.776h1.752l10.416 14.208z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.96 67.534h1.464v6.144q-1.224 1.032-2.856 1.632-1.608 0.576-3.288 0.576-2.376 0-4.392-1.152-1.992-1.152-3.168-3.12-1.176-1.968-1.176-4.296 0-2.328 1.176-4.272 1.176-1.944 3.192-3.072 2.04-1.152 4.44-1.152 1.704 0 3.288 0.6 1.608 0.6 2.832 1.68l-0.96 1.176q-1.032-0.96-2.376-1.464-1.344-0.528-2.784-0.528-1.944 0-3.576 0.96-1.632 0.936-2.592 2.544-0.96 1.608-0.96 3.528 0 1.944 0.96 3.576 0.96 1.608 2.592 2.568 1.656 0.936 3.6 0.936 1.2 0 2.376-0.384 1.2-0.408 2.208-1.128z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.29 58.966h1.656v16.776h-1.656z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.4 58.966h1.632v16.776h-1.752l-10.392-14.208v14.208h-1.656v-16.776h1.752l10.416 14.208z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.33 58.966h11.232v1.488h-9.576v6h8.568v1.488h-8.568v6.312h9.888v1.488h-11.544z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ea4991ca57154f84951f9ba02c499082.svg";
export { ForwardRef as ReactComponent };